export default {
    C1: {
        'event': 'key-interaction',
        'lineOfBusiness': 'ent: interaction',
        'userActionTaken': 'search',
        'buttonLocation': 'top', 
        'siteSection': 'map',
        'clickText': '{{lower case search terms}}', //e.g., "housing," "90210," etc
    },
    C2: {
        'event': 'key-interaction',
        'lineOfBusiness': 'ent: interaction',
        'userActionTaken': 'learn more',
        'buttonLocation': 'top', 
        'siteSection': 'map',
        'clickText': 'state selector: {{lower case state}}', //e.g., "alabama"
    },
    C3: {
        'event': 'key-interaction',
        'lineOfBusiness': 'ent: interaction',
        'userActionTaken': 'learn more',
        'buttonLocation': 'top', 
        'siteSection': 'map',
        'clickText': 'district selector: {{district number}}', //e.g., "1"
    },
    C4: {
        'event': 'key-interaction',
        'lineOfBusiness': 'ent: interaction',
        'userActionTaken': 'learn more',
        'buttonLocation': 'mid', 
        'siteSection': 'map',
        'clickText': 'issue selector: {{lower case issue}}', //e.g., "housing affordability"
    },
    C5: {
        'event': 'key-interaction',
        'lineOfBusiness': 'ent: interaction',
        'userActionTaken': 'learn more',
        'buttonLocation': 'bottom', 
        'siteSection': 'map',
        'clickText': 'pagination: {{page number}}', //e.g., "2,"
       },
}